import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PolicyModal from '../PolicyModal/PolicyModal';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const navigate = useNavigate();
  const [activeModal, setActiveModal] = useState(null);

  const navLinks = [
    { id: 'inicio', label: 'Inicio', path: '/' },
    { id: 'servicios', label: 'Servicios', path: '/servicios' },
    { id: 'nosotros', label: 'Nosotros', path: '/nosotros' },
    { id: 'contacto', label: 'Contacto', path: '/contacto' },
  ];

  const services = [
    'Sistemas de Gestión',
    'Asesoría en Certificaciones',
    'Capacitación Especializada',
    'Gestión Estratégica de TI',
    'Auditorías Internas',
    'Consultoría ISO',
  ];

  const contactInfo = [
    { icon: '✉', text: 'info@isqsservices.mx', type: 'email' },
    { icon: '📍', text: 'Ciudad de México, México', type: 'location' },
    { icon: '🌐', text: 'www.isqsservices.mx', type: 'website' },
  ];

  const policyContents = {
    privacy: (
      <>
        <h3>Información que Recopilamos</h3>
        <p>En ISQS Services recopilamos información que usted nos proporciona directamente cuando se comunica con nosotros, solicita información sobre nuestros servicios o se suscribe a nuestro boletín.</p>
        <h3>Cómo Utilizamos su Información</h3>
        <p>Utilizamos la información para brindar nuestros servicios, comunicarnos con usted y mejorar continuamente nuestra oferta.</p>
        <h3>Protección de Datos</h3>
        <p>Implementamos medidas de seguridad técnicas y organizativas para proteger su información personal.</p>
        <h3>Contacto</h3>
        <p>Si tiene preguntas, contáctenos en: <strong>info@isqsservices.mx</strong></p>
      </>
    ),
    terms: (
      <>
        <h3>Aceptación de los Términos</h3>
        <p>Al acceder y utilizar el sitio web de ISQS Services, usted acepta estar sujeto a estos términos de servicio.</p>
        <h3>Servicios Ofrecidos</h3>
        <p>ISQS Services proporciona servicios de consultoría profesional en sistemas de gestión, certificaciones ISO e ITIL, y capacitación especializada.</p>
        <h3>Propiedad Intelectual</h3>
        <p>Todo el contenido del sitio web es propiedad de ISQS Services y está protegido por las leyes de propiedad intelectual.</p>
        <h3>Ley Aplicable</h3>
        <p>Estos términos se rigen por las leyes de México. Cualquier disputa será resuelta en los tribunales de Ciudad de México.</p>
      </>
    ),
    cookies: (
      <>
        <h3>¿Qué son las Cookies?</h3>
        <p>Las cookies son pequeños archivos de texto que se almacenan en su dispositivo para mejorar su experiencia de navegación.</p>
        <h3>Cookies que Utilizamos</h3>
        <p>Utilizamos cookies esenciales para el funcionamiento del sitio y cookies de análisis para entender cómo los usuarios interactúan con nuestro contenido.</p>
        <h3>Control de Cookies</h3>
        <p>Puede controlar las cookies a través de la configuración de su navegador.</p>
      </>
    ),
  };

  const handleNavClick = (path) => {
    navigate(path);
    setTimeout(() => window.scrollTo({ top: 0, behavior: 'smooth' }), 100);
  };

  const handleContactClick = (type, value) => {
    if (type === 'email') window.open(`mailto:${value}`);
    else if (type === 'website') window.open(`https://${value}`, '_blank');
  };

  return (
    <>
      <footer className="footer">
        <div className="footer__main">
          <div className="container">
            <div className="footer__grid">

              {/* Brand */}
              <div className="footer__brand">
                <div className="footer__logo">
                  <img src="/logobien.png" alt="ISQS Services" className="footer__logo-img" />
                </div>
                <p className="footer__desc">
                  Consultoría profesional en sistemas de gestión y certificaciones
                  para organizaciones de sectores estratégicos en México.
                </p>
                <a
                  href="https://www.linkedin.com/in/servio-reyes-mar-53362822/"
                  className="footer__linkedin"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                  </svg>
                  LinkedIn
                </a>
              </div>

              {/* Navegación */}
              <div className="footer__col">
                <h4 className="footer__col-title">Navegación</h4>
                <ul className="footer__links">
                  {navLinks.map(link => (
                    <li key={link.id}>
                      <button onClick={() => handleNavClick(link.path)} className="footer__link">
                        {link.label}
                      </button>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Servicios */}
              <div className="footer__col">
                <h4 className="footer__col-title">Servicios</h4>
                <ul className="footer__links">
                  {services.map(s => (
                    <li key={s}>
                      <button onClick={() => handleNavClick('/servicios')} className="footer__link">
                        {s}
                      </button>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Contacto */}
              <div className="footer__col">
                <h4 className="footer__col-title">Contacto</h4>
                <ul className="footer__contact-list">
                  {contactInfo.map(c => (
                    <li key={c.text}>
                      <button onClick={() => handleContactClick(c.type, c.text)} className="footer__contact-item">
                        <span className="footer__contact-icon">{c.icon}</span>
                        <span>{c.text}</span>
                      </button>
                    </li>
                  ))}
                </ul>
              </div>

            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="footer__bottom">
          <div className="container">
            <div className="footer__bottom-inner">
              <p className="footer__copy">© {currentYear} ISQS Services. Todos los derechos reservados.</p>
              <div className="footer__legal">
                <button className="footer__legal-link" onClick={() => setActiveModal('privacy')}>Política de Privacidad</button>
                <span>·</span>
                <button className="footer__legal-link" onClick={() => setActiveModal('terms')}>Términos de Servicio</button>
                <span>·</span>
                <button className="footer__legal-link" onClick={() => setActiveModal('cookies')}>Cookies</button>
              </div>
            </div>
          </div>
        </div>
      </footer>

      <PolicyModal isOpen={activeModal === 'privacy'} onClose={() => setActiveModal(null)} title="Política de Privacidad" content={policyContents.privacy} />
      <PolicyModal isOpen={activeModal === 'terms'} onClose={() => setActiveModal(null)} title="Términos de Servicio" content={policyContents.terms} />
      <PolicyModal isOpen={activeModal === 'cookies'} onClose={() => setActiveModal(null)} title="Política de Cookies" content={policyContents.cookies} />
    </>
  );
};

export default Footer;
